import * as types from "./types";

export const logout = () => ({
  type: types.LOGOUT,
});

export const clearReduxStore = () => ({
  type: types.CLEAR_REDUX_STORE,
});
